export default "__VITE_ASSET__BlhgjUap__"